import { render } from "./PlaybookTypeDetails.vue?vue&type=template&id=4af78c97&scoped=true"
import script from "./PlaybookTypeDetails.vue?vue&type=script&lang=js"
export * from "./PlaybookTypeDetails.vue?vue&type=script&lang=js"

import "./PlaybookTypeDetails.vue?vue&type=style&index=0&id=4af78c97&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af78c97"],['__file',"resources/js/components/playbooks/admin/PlaybookTypeDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4af78c97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4af78c97', __exports__)) {
    api.reload('4af78c97', __exports__)
  }
  
  module.hot.accept("./PlaybookTypeDetails.vue?vue&type=template&id=4af78c97&scoped=true", () => {
    api.rerender('4af78c97', render)
  })

}


export default __exports__